@if (environment && !(environment.name === 'prod')) {
  <hr class="environment-{{environment.name}}">
}
<app-loading></app-loading>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
